import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createRefundMutation } from "@/app/Refunds/GraphQL/refundMutations";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { CurrencyTypeInput } from "@/app/Common/Components/CurrencyTypeInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useFormState } from "@/lib/Components/Form/Hooks/useFormState";
import { Currency, ModelType, RefundType } from "@/gql/graphql";

type CreateRefundValues = {
  currency: Currency;
  maximum_refund_amount: number;
};

export function CreateRefundDialog({
  bookingId,
  refundType,
  defaultCurrency,
}: {
  bookingId: string;
  refundType: RefundType;
  defaultCurrency: Currency;
}) {
  const { mutateAsync } = useGqlMutation(createRefundMutation);
  const { close } = useDialogState();

  const title =
    refundType === RefundType.Fuel
      ? "Create Fuel Refund"
      : "Create Ferry Refund";

  return (
    <BaseDialog title={title} size="md">
      <GenericForm<CreateRefundValues>
        initialValues={{
          currency: defaultCurrency,
          maximum_refund_amount: 0,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            object: { id: bookingId, type: ModelType.Booking },
            type: refundType,
            input: {
              currency: values.currency,
              maximum_refund_amount: values.maximum_refund_amount,
            },
          });

          close();
        }}
      >
        <CurrencyTypeInput
          name="currency"
          label="Currency"
          className="col-span-6"
        />
        <AmountInput />
        <DialogSubmitButton text="Create Refund" />
      </GenericForm>
    </BaseDialog>
  );
}

function AmountInput() {
  const { values } = useFormState<CreateRefundValues>();
  return (
    <CurrencyInput
      name="maximum_refund_amount"
      label="Maximum Refund Amount"
      currency={values.currency}
      autoFocus
      className="col-span-6"
    />
  );
}
